export const ErrorTypes = {
    PropertyFinderError: 'pf-error',
    PropertyFinderWarning: 'pf-warning',
};

export const ErrorNameSpaces = {
    PropertyFinder: 'PFError'
}